const sanitizeHtml = (html) => {
  // Sanitize the text to remove any potentially dangerous HTML
  return html.replace(/<script.*?>.*?<\/script>/gi, "");
};

const waitForElementBySelector = (selector, retries = 5, delay = 500) => {
  return new Promise((resolve) => {
    let attempts = 0;

    const interval = setInterval(() => {
      const elm = document.querySelector(selector);

      if (elm) {
        clearInterval(interval);
        resolve(elm);
      } else if (attempts >= retries) {
        clearInterval(interval);
        resolve(null);
      }
      attempts += 1;
    }, delay);
  });
};

const waitForElement = (id, retries = 5, delay = 500) => {
  return waitForElementBySelector(
    id.startsWith("#") ? id : `#${id}`,
    retries,
    delay
  );
};

const displayDateShort = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const calcReadTime = (text) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, "text/html");
  const textContent = doc.body.textContent || "";
  const words = textContent.split(/\s+/).filter(Boolean).length || 0;
  const readTime = Math.round(words / 200) || 1;
  return readTime;
};

const randomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Updated function to simply return the text without any modifications
const prepareGuideTitle = (text) => {
  if (!text) return "";
  return text;
};

const injectQuillLink = () => {
  const link = document.createElement("link");

  link.rel = "stylesheet";
  link.href =
    "https://cdnjs.cloudflare.com/ajax/libs/quill/2.0.2/quill.snow.css";
  link.id = "quill-style";
  document.head.appendChild(link);

  return link;
};

const handleOpenSocialLink = (platform) => {
  let shareUrl;
  switch (platform) {
    case "facebook":
      shareUrl = `https://www.facebook.com/profile.php?id=61575338819483`;
      break;
    case "twitter":
      shareUrl = `https://x.com/reachthepeople_`;
      break;
    case "linkedin":
      shareUrl = `https://www.linkedin.com/company/reachthepeopleai/`;
      break;
    case "instagram":
      shareUrl = `https://www.instagram.com/reachthepeople_ai/`;
      break;
    default:
      return;
  }

  window.open(shareUrl, "_blank");
};

const transformCampaignProfessionalRolesToOptions = (roles) => {
  if (!roles) return [];

  const options = [];

  Object.entries(roles).forEach(([categoryKey, categoryData]) => {
    options.push({
      value: `category_${categoryKey}`,
      label: categoryData.value,
      isCategory: true,
      disabled: true,
    });

    Object.entries(categoryData.roles).forEach(([roleKey, roleLabel]) => {
      options.push({
        value: roleKey,
        label: roleLabel,
        category: categoryKey,
        isCategory: false,
      });
    });
  });

  return options;
};

const getAllCampaignRoles = (roles) => {
  if (!roles) return {};

  const result = {};

  Object.values(roles).map((m) =>
    Object.entries(m.roles).map(([key, value]) => {
      result[key] = value;
    })
  );

  return result;
};

const displayNumber = (val) => {
  if (typeof val === "number") {
    return val.toLocaleString("en-US");
  }
  return "";
};

const displayCurrency = (amount, currency) => {
  if (typeof amount !== "number") {
    return "";
  }

  const value = amount / 100;

  try {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: currency || "USD",
    });
  } catch {
    return `$${displayNumber(value)}`;
  }
};

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const isDonationSubdomain = () => {
  const hostname = window.location.hostname;
  return hostname === "raise.reachthepeople.ai";
};

// Data API portal host detection moved to src/lib/portalHost.js (sync resolution) +
// src/hooks/usePortalHostDecision.js (runtime branding probe for reseller white-label domains).

export {
  sanitizeHtml,
  waitForElementBySelector,
  waitForElement,
  displayDateShort,
  calcReadTime,
  randomNumber,
  prepareGuideTitle,
  injectQuillLink,
  handleOpenSocialLink,
  transformCampaignProfessionalRolesToOptions,
  getAllCampaignRoles,
  displayNumber,
  displayCurrency,
  fileToBase64,
  sleep,
  isDonationSubdomain,
};
